import React from "react";
import TopHeader from "../../Components/TopHeader";
import EmailSubscription from "../../Components/EmailSubscription";
import Footer from "../../Components/Footer";
import { Link } from "react-router-dom";
const Community = () =>{

    return (
        <>
        <TopHeader/>
        <div className="main-container no-overflow-x pt-0 -with-cta-banner">
  <div
    className="w-100 text-center"
    data-controller="community"
  >
    <div className="community-header">
      <div className="content">
        <h1 className="header pb-md-2 mb-4">
          Our Community
        </h1>
        <p className="description mb-0">
          If you’re wearing it, we want to see it! Just tag @
          <span className="hurr-font-logo">
            CIRCULAR
          </span>
          {' '}in your uploads to be featured on our community feed. Nothing goes better with style than a smile.
        </p>
      </div>
    </div>
    <div className="my-4 mx-2">
      {' '}
      <span
        className="PIN_1706938782878_embed_grid PIN_1706938782878_c3 PIN_1706938782878_board"
        data-pin-href="https://www.pinterest.com"
        data-pin-log="embed_grid"
      >
        <span
          className="PIN_1706938782878_hd"
          data-pin-href="https://www.pinterest.com/hurrhq/"
          data-pin-log="embed_grid"
        >
          <span
            className="PIN_1706938782878_img"
            data-pin-href="https://www.pinterest.com/hurrhq/"
            data-pin-log="embed_grid"
            style={{
              backgroundImage: 'url("https://i.pinimg.com/60x60_RS/38/20/c7/3820c706672bd1dd758a922d475b3e7a.jpg")'
            }}
          />
          <span
            className="PIN_1706938782878_pinner"
            data-pin-href="https://www.pinterest.com/hurrhq/"
            data-pin-log="embed_grid"
          >
            CIRCULAR
          </span>
          <span
            className="PIN_1706938782878_board"
            data-pin-href="https://www.pinterest.com/hurrhq/hurr-community/"
            data-pin-log="embed_grid"
          >
            CIRCULAR Community
          </span>
        </span>
        <span
          className="PIN_1706938782878_bd"
          data-pin-href="https://www.pinterest.com"
          data-pin-log="embed_grid"
          style={{
            height: '1000px'
          }}
        >
          <span
            className="PIN_1706938782878_ct"
            data-pin-href="https://www.pinterest.com"
            data-pin-log="embed_grid"
          >
            <span
              className="PIN_1706938782878_col"
              data-pin-href="https://www.pinterest.com"
              data-pin-log="embed_grid"
            >
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508891214792"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(178, 132, 114)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/de/c0/d8/dec0d8661b01ae26a0e3412fd403963b.jpg")',
                  paddingBottom: '123.305%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888990467"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(178, 178, 186)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/cf/ec/7f/cfec7f15f1589ed8112621a89f825519.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888941362"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(178, 178, 186)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/cf/ec/7f/cfec7f15f1589ed8112621a89f825519.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888941352"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(217, 195, 180)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/2c/87/cc/2c87cc15aa6c2c5ad92bd135479d428f.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888810015"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(149, 149, 151)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/ec/c2/d1/ecc2d1302a25993b4e11307dd16d16a6.jpg")',
                  paddingBottom: '177.542%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888810010"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(127, 127, 121)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/f3/ec/c4/f3ecc441e67cbbe5848a8194d5e54623.jpg")',
                  paddingBottom: '177.542%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888809851"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(63, 77, 79)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/cc/77/59/cc7759dfbc32b2a87a919d678e08a8b8.jpg")',
                  paddingBottom: '133.051%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888758391"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(178, 178, 186)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/cf/ec/7f/cfec7f15f1589ed8112621a89f825519.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888749411"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(217, 195, 180)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/2c/87/cc/2c87cc15aa6c2c5ad92bd135479d428f.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885439412"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(155, 146, 119)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/65/6b/66/656b6612d1d78ba0e51336bb14a88382.jpg")',
                  paddingBottom: '149.576%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885439132"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(100, 75, 40)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/17/d0/86/17d08662dbf7bfb1857a72bd53a631ee.jpg")',
                  paddingBottom: '150%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885320871"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(153, 139, 122)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/ba/8b/af/ba8baf896eceb2aeda9a734b6c0245e5.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885320855"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(177, 163, 145)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/3f/85/ce/3f85cefde35310e43a780d28af03abdf.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885201540"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(99, 49, 22)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/55/c2/23/55c223ea3d6bc37be71d7602f016f3b4.jpg")',
                  paddingBottom: '150%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885137609"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(201, 168, 163)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/5e/09/37/5e09372a70d3db7c9620b6e97ada3806.jpg")',
                  paddingBottom: '177.542%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885137585"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(121, 114, 101)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/48/68/97/4868978eaa7855c1ae8255c1853fbf43.jpg")',
                  paddingBottom: '150%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508884860357"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(208, 188, 208)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/31/ef/15/31ef150f8861563be954e2dae4c585a9.jpg")',
                  paddingBottom: '150%'
                }}
              />
            </span>
            <span
              className="PIN_1706938782878_col"
              data-pin-href="https://www.pinterest.com"
              data-pin-log="embed_grid"
            >
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508891108797"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(186, 189, 163)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/72/23/ef/7223ef43588765ede2f409b0e0c6251d.jpg")',
                  paddingBottom: '177.542%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888941363"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(201, 176, 172)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/30/fe/0f/30fe0f6d8f2a1ebfd37997961ea29d46.jpg")',
                  paddingBottom: '124.576%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888941353"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(178, 178, 186)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/cf/ec/7f/cfec7f15f1589ed8112621a89f825519.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888941287"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(156, 148, 111)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/57/a4/0e/57a40e8c4aba51d3efc9cfade22f203d.jpg")',
                  paddingBottom: '177.542%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888810012"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(216, 168, 175)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/12/ab/64/12ab644ee95ab2329bd25c162b788a2a.jpg")',
                  paddingBottom: '177.542%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888809852"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(216, 174, 116)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/be/ca/ae/becaaee3d1ea5bbaa5877ecc4b10c28a.jpg")',
                  paddingBottom: '150%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888758396"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(162, 177, 173)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/b2/c3/f0/b2c3f00abe0ed7af500b339ccaf5547b.jpg")',
                  paddingBottom: '149.576%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888749414"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(138, 109, 84)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/6a/bc/2d/6abc2d3d750cae8ddf33546363623862.jpg")',
                  paddingBottom: '125.424%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885439418"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(115, 102, 101)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/b7/cc/31/b7cc31eed8c2f44925f1d7bcd725e478.jpg")',
                  paddingBottom: '100%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885439139"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(111, 118, 79)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/07/3f/77/073f7771ff4d51f130a3a00ddf8c946a.jpg")',
                  paddingBottom: '150%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885320880"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(171, 156, 122)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/ad/2d/f8/ad2df89f4e9ebc1115bc08d0a3a92cac.jpg")',
                  paddingBottom: '149.576%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885320862"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(194, 189, 179)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/2c/92/b0/2c92b07f42357b00c77e7a469e5c8689.jpg")',
                  paddingBottom: '149.576%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885320852"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(203, 200, 190)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/d9/47/a3/d947a372aacfa126887cb9146fcf9d89.jpg")',
                  paddingBottom: '149.576%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885137619"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(202, 169, 165)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/f5/c0/95/f5c0951732cbe763e4ac34b68c39eaee.jpg")',
                  paddingBottom: '177.542%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885137592"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(196, 197, 185)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/8b/f5/96/8bf596cb1ee2d95b4019b471ca1438e5.jpg")',
                  paddingBottom: '150%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885137563"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(121, 114, 101)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/48/68/97/4868978eaa7855c1ae8255c1853fbf43.jpg")',
                  paddingBottom: '150%'
                }}
              />
            </span>
            <span
              className="PIN_1706938782878_col"
              data-pin-href="https://www.pinterest.com"
              data-pin-log="embed_grid"
            >
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888990470"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(162, 177, 173)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/b2/c3/f0/b2c3f00abe0ed7af500b339ccaf5547b.jpg")',
                  paddingBottom: '149.576%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888990466"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(217, 195, 180)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/2c/87/cc/2c87cc15aa6c2c5ad92bd135479d428f.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888941360"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(217, 195, 180)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/2c/87/cc/2c87cc15aa6c2c5ad92bd135479d428f.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888941300"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(131, 122, 104)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/83/7d/d5/837dd54ff740b68a4ee4046ba4a7a3f0.jpg")',
                  paddingBottom: '177.542%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888810013"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(114, 72, 75)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/57/86/76/5786762f82977dde3f1e9d512a440ada.jpg")',
                  paddingBottom: '177.542%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888810009"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(217, 195, 180)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/2c/87/cc/2c87cc15aa6c2c5ad92bd135479d428f.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888809833"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(91, 88, 96)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/dc/5e/d2/dc5ed2a4abd461f0d0de89109a3ce8df.jpg")',
                  paddingBottom: '150%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508888758390"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(217, 195, 180)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/2c/87/cc/2c87cc15aa6c2c5ad92bd135479d428f.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885439429"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(214, 208, 197)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/14/b4/0c/14b40c0270ebd6a60c8706cfca406d4a.jpg")',
                  paddingBottom: '149.576%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885439151"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(150, 126, 139)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/53/d9/a0/53d9a0775546c302edb3dbfd14be050c.jpg")',
                  paddingBottom: '150%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885439125"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(108, 105, 81)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/8b/83/04/8b8304063eb8bc5942e704d5b68ada82.jpg")',
                  paddingBottom: '150%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885320863"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(217, 195, 180)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/2c/87/cc/2c87cc15aa6c2c5ad92bd135479d428f.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885320854"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(215, 209, 202)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/71/b7/f1/71b7f10b4e3be94b1cccc956d00bdaf7.jpg")',
                  paddingBottom: '125%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885137632"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(202, 193, 188)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/00/e7/14/00e7146ba9c9463ff60f822703b53f18.jpg")',
                  paddingBottom: '124.576%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885137596"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(155, 149, 140)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/1b/b8/13/1bb8138d3941d8552382c3494ce595a8.jpg")',
                  paddingBottom: '150%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508885137574"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(225, 223, 224)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/b6/c3/6c/b6c36ca860ad345c76abbf4ca6a53382.jpg")',
                  paddingBottom: '150%'
                }}
              />
              <span
                className="PIN_1706938782878_img"
                data-pin-href="https://www.pinterest.com/pin/497014508884781368"
                data-pin-log="embed_grid"
                style={{
                  backgroundColor: 'rgb(138, 149, 159)',
                  backgroundImage: 'url("https://i.pinimg.com/236x/33/05/d4/3305d47de5944c1a64eac9d51c9a98d4.jpg")',
                  paddingBottom: '155.932%'
                }}
              />
            </span>
          </span>
        </span>
        <span
          className="PIN_1706938782878_ft"
          data-pin-href="https://www.pinterest.com/hurrhq/hurr-community/follow/?guid=zk3EfaLqhn7B"
          data-pin-log="embed_user_ft"
        >
          <span
            className="PIN_1706938782878_button"
            data-pin-href="https://www.pinterest.com/hurrhq/hurr-community/follow/?guid=zk3EfaLqhn7B"
            data-pin-log="embed_user_ft"
          >
            <span
              className="PIN_1706938782878_label PIN_1706938782878_bottom"
              data-pin-href="https://www.pinterest.com/hurrhq/hurr-community/follow/?guid=zk3EfaLqhn7B"
              data-pin-log="embed_user_ft"
            >
              <span
                className="PIN_1706938782878_string"
                data-pin-href="https://www.pinterest.com/hurrhq/hurr-community/follow/?guid=zk3EfaLqhn7B"
                data-pin-log="embed_board_ft"
              >
                Follow On{' '}
              </span>
              <span
                className="PIN_1706938782878_logo"
                data-pin-href="https://www.pinterest.com/hurrhq/hurr-community/follow/?guid=zk3EfaLqhn7B"
                data-pin-log="embed_board_ft"
              />
            </span>
          </span>
        </span>
      </span>
    </div>
  </div>
</div>
        <EmailSubscription/>
        <Footer/>
        </>
    )
}
export default Community;